var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgStarFilled = function SvgStarFilled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.40156 14.0996L3.10156 9.89961L9.00156 8.99961L11.7016 3.59961L14.4016 8.99961L20.3016 9.89961L16.0016 14.0996L17.0016 19.9996L11.7016 17.1996L6.40156 19.9996L7.40156 14.0996Z",
    fill: "#FFC400"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 9.3L20.4 9.1L14.8 8.3L12.3 3.3L11.7 2L11 3.3L8.6 8.5C6.7 8.8 4.8 9.1 3 9.4L2 9.6L2.7 10.2L5.5 12.7C5.6 12.8 5.8 12.8 5.9 12.7C6 12.6 6 12.4 5.9 12.3L4 10.3C5.7 10.1 7.4 9.9 9.1 9.7H9.4L9.6 9.4L11.7 5.3L13.7 9.4L13.9 9.8L14.3 9.9L18.7 10.6L15.5 13.7L15.2 14L15.3 14.4L16.1 18.9C14.7 18.2 13.4 17.5 12 16.8L11.7 16.6L11.4 16.8L7 19.1L7.7 14.1C7.7 13.9 7.6 13.8 7.5 13.8C7.3 13.8 7.2 13.9 7.2 14L5.8 20L5.6 21L6.5 20.5L11.6 18C13.3 18.9 14.9 19.8 16.6 20.7L17.9 21.4L17.7 20L16.8 14.5L20.8 10.6L22 9.3Z",
    fill: "black"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStarFilled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/star-filled.5cd7646d.svg";
export { ForwardRef as ReactComponent };